{
  "removeButtonLabel": "Verwijderen",
  "removeDescription": "Druk op Verwijderen om de tag te verwijderen."
}
